import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { Category,Product } from 'src/app/app.models';
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {catchError, map, shareReplay} from "rxjs/operators";

export interface CategoryListItem {
    key: string;
    name: string;
}
@Injectable()
export class CategoryService {
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apiUrl.getJWTToken()
        })
    }

    public url = "api/mainCategory";
    constructor(public http: HttpClient,
                public apiUrl: ApiUrl) { }
    private categories$: Observable<CategoryListItem[]>;

    // Fetch and cache the data
    getPages(): Observable<any>{
        return this.http.get(this.apiUrl.getPages(), this.options)
            .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
            );
    }
    getCategories(): Observable<CategoryListItem[]> {
        if (!this.categories$) {
            this.categories$ = this.getPages()
                .pipe(
                    // Transform the response
                    // Replace buildCategoryList with your logic if needed
                    map(res => this.buildCategoryList(res)),
                    // Cache the result and share with all subscribers
                    shareReplay(1)
                );
        }
        return this.categories$;
    }

    private buildCategoryList(json: any): any {
        const result: CategoryListItem[] = [];
        json.forEach(cate => {
            result.push({ key: cate.category, name: cate.name })
            if (Array.isArray(cate.subcategories)) {
                cate.subcategories.forEach((sub: any) => {
                    result.push({
                        key: sub.id,
                        name: sub.name
                    });
                });
            }
        })
        const arr={}
        result.forEach(cate=> arr[cate.key] = {key: cate.key, name: cate.name})
        return arr;
    }

    private handleObserverError(error: any): Observable<any>{
        console.log(error)
        return throwError(error.error || error)
    }

    getCategory(): Observable<any> {
        return this.http.get<any>(this.apiUrl.getCategory(), this.options).pipe(map((res) => res ? res : null ),catchError(this.handleObserverError));
    }

    addCategory(store:any): Observable<any>{
        return this.http.post<any>(this.apiUrl.getCategory(), JSON.stringify(store), this.options);
    }
    updateCategory(category:Category){
        return this.http.patch(this.apiUrl.getCategory() + category.id + "/", category);
    }

    deleteCategory(id: number) {
        return this.http.delete(this.apiUrl.getCategory() + id + "/", this.options);
    } 
} 
